/**
 * COMMON API ENDPOINTS
 */
import xhr from './../utils/xhr';
import utils from './../utils/utilities';
import {LOCALES} from './../constants';

const api = {
    getEntities() {
        return xhr.get({
            url: '/api/entities/active?pageNumber=-1&pageSize=-1&sortBy=companyTitleSort&direction=asc'
        }).then((response) => {
            let entities = {};
            for (let i = 0; i < response.body.length; i++) {
                entities[response.body[i].id] = response.body[i].companyTitle;
            }
            return entities;
        })
    },

    updateUserPrefs: function(prefs) {
        return xhr.put({
            url:    '/api/user',
            data: prefs
        }).catch((error) => {
            console.log("************** Failed to update user prefs *************");
            xhr.handleAllErrors(error);
        });
    },

    loadCompanyData: (companyId) => {
        return xhr.get({
            url: '/api/entities/company/'+ companyId
        }).then((response) => {
            return response.body;
        })
    },

    loadListingTimestamp: function() {
        return xhr.get({
            url: '/api/articles/latestTimestamp'
        }).then((response) => {
            return response.body;
        });
    },

    loadSingleArticle(articleId) {
        return xhr.get({
            url: '/api/entities/preview-article/' + articleId
        }).then((response) => {
            return response.body;
        });
    },

    loadCount(url, urlParams) {
        return xhr.post({
            url,
            data: urlParams
        }).then((response) => {
            return response.body;
        });
    },

    getPendingUpload: function() {
        return xhr.get({
            url: '/api/template/lastUpload/'
        }).then((response) => {
            return response.body;
        });
    },

    getPguidDescriptions(pguids) {

        return xhr.post({
            url:  "/api/system/pguidDescriptions",
            data: pguids
        }).then((response) => {

            for (let i = 0; i < pguids.length; i++) {
                if (!response.body[pguids[i]]) {
                    LOCALES['en-us'].translations['pguidDescription_' + pguids[i]] = LOCALES['en-us'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
                    LOCALES['en-gb'].translations['pguidDescription_' + pguids[i]] = LOCALES['en-gb'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
                    LOCALES['de'].translations['pguidDescription_' + pguids[i]] = LOCALES['de'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
                    LOCALES['fr'].translations['pguidDescription_' + pguids[i]] = LOCALES['fr'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
                    continue;
                }

                let defVal = response.body[pguids[i]]['en_us'];
                if (!defVal || defVal === '--' || defVal === '') {
                    defVal = '';
                }
                let gb = response.body[pguids[i]]['en_gb'];
                if (!gb || gb === '--' || gb === '') {
                    gb = defVal;
                }
                let de = response.body[pguids[i]]['de'];
                if (!de || de === '--' || de === '') {
                    de = defVal;
                }
                let fr = response.body[pguids[i]]['fr'];
                if (!fr || fr === '--' || fr === '') {
                    fr = defVal;
                }
                LOCALES['en-us'].translations['pguidDescription_' + pguids[i]] = defVal;
                LOCALES['en-gb'].translations['pguidDescription_' + pguids[i]] = gb;
                LOCALES['de'].translations['pguidDescription_' + pguids[i]] = de;
                LOCALES['fr'].translations['pguidDescription_' + pguids[i]] = fr;
            }
        }).catch((error) => {
            utils.logError(error);
            for (let i = 0; i < pguids.length; i++) {
                LOCALES['en-us'].translations['pguidDescription_' + pguids[i]] = LOCALES['en-us'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
                LOCALES['en-gb'].translations['pguidDescription_' + pguids[i]] = LOCALES['en-gb'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
                LOCALES['de'].translations['pguidDescription_' + pguids[i]] = LOCALES['de'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
                LOCALES['fr'].translations['pguidDescription_' + pguids[i]] = LOCALES['fr'].translations['General_CoreFunctionality_UIText_general.notAvailableShort'];
            }
        });

    },

    createDelivery: payload => {
        return xhr.post({
            url: '/api/delivery/create',
            data: payload
        }).then((response) => {
            return response.body;
        });
    },

    getDeliveryStatus: id => {
        return xhr.get({
            url: '/api/delivery/' + id + '/status'
        }).then(response => {
            return response.body.status;
        });
    },

    downloadDelivery: id => {
        return xhr.get({
            url: `/api/delivery/${id}/download?`
        }).then((response) => {
            return response;
        });
    }
};

export default api;


// WEBPACK FOOTER //
// ./src/scripts/api/Common.api.js